export const POST_TYPES = ['post', 'story', 'reel'] as const;
